import React from 'react';

export default function NotAuthenticatedPage() {
  return <h1>Please authenticate</h1>;
}
